define([
	"dojo/_base/declare",
	"csi",
	"csi/action/Controller",
	"csi/locale",
	"csi/resolver",
	"csi/widget/MessageDialog"
], function(declare,csi,Controller,locale,resolver,MessageDialog) {

	return declare(Controller, {
		preProcess: function() {
			// summary: do not allow action if style already has a theme
			var supplierRequest = this.getParent();
			if(supplierRequest.StockOrder != csi.EMPTY_URL) {
				var stockOrder = resolver.resolveNode(supplierRequest.StockOrder, true);
				if(stockOrder.State != "StockOrderState:Draft") {
					this.displayErrorDialog({
						materialIcon: MessageDialog.ICON_WARNING,
						message: this.getString("_Error"),
						title: locale.resource("WARNING")
					});
					return;
				}
			}
			this.inherited(arguments);
		}
	});
});